<div class="px-3 py-5">
    <div class="theme-container">
        <mat-card class="p-0 o-hidden">
            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="50" class="p-0" [style.background-image]="bgImage" class="bg-cover">
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="py-3" ngClass.gt-sm="px-5" ngClass.sm="px-3"
                    ngClass.xs="px-3">
                    <div fxLayout="column" fxLayoutAlign="center center" class="text-center">
                        <h1 class="secondary-font">Valider votre N° de telephone</h1>
                    </div>
                    <form [formGroup]="loginForm" *ngIf="user != null">
                     <mat-form-field appearance="outline" class="w-100">
                         <mat-label>Numero de telephone</mat-label>
                         <input  matInput formControlName="number"  required>
                    </mat-form-field>
                     <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Code</mat-label>
                            <input matInput formControlName="code" required maxlength="6"  minlength="6" >
                            <mat-error *ngIf="loginForm.controls.code.errors?.required">veillez entre le Code de validation  </mat-error>
                            <mat-error *ngIf="loginForm.controls.code.hasError('maxlength')">code incorrect veillez reessayer 6 chiffres maximun ex: 190705 </mat-error>
                            <mat-error *ngIf="loginForm.controls.code.hasError(' minlength')">code incorrect veillez reessayer 6 chiffres maximun ex: 190709 </mat-error>
                     </mat-form-field>
                        <div class="text-center mt-2">
                            <button *ngIf="index < 3 || index == 4"  mat-raised-button color="accent" class="uppercase" type="submit" [disabled]="!loginForm.valid" (click)="onLoginFormSubmit()">
                                Envoyer
                            </button>
                            <button *ngIf="index == 3"  class="text-right"  (click)="reset()" mat-raised-button   color="accent">
                                Obtenir un nouveau code  
                            </button>
                            <a mat-button routerLink="/create-utilisateurs" color="accent" class="w-100">Vous n'avez pas de compte ? S'inscrire 
                            </a>
                        </div>
                    </form>
                </div>
            </div>
        </mat-card>
    </div>
</div>